import { Inbox } from "lucide-react";

const EmptyTablePlaceholder = ({ message, title }: any) => {
  return (
    <div className="flex items-center justify-center flex-col w-full py-16">
      <div className="flex items-center justify-center w-12 h-12 rounded-full bg-muted text-muted-foreground mb-3">
        <Inbox className="h-6 w-6" />
      </div>
      <p className="text-sm font-semibold text-foreground">
        {title || "No Records Available"}
      </p>
      <p className="text-sm text-muted-foreground text-center max-w-[90%] break-words">
        {message || "We couldn't find any data to display at the moment."}
      </p>
    </div>
  );
};

export default EmptyTablePlaceholder;
